<template>
    <svg :width="width" :height="height" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.4014 23.5239L7.60206 23.5239C6.29304 23.5239 5.23187 24.5851 5.23187 25.8941L5.23187 25.896C5.23187 27.205 6.29304 28.2662 7.60206 28.2662L26.4014 28.2662C27.7105 28.2662 28.7716 27.205 28.7716 25.896L28.7716 25.8941C28.7716 24.5851 27.7105 23.5239 26.4014 23.5239Z"
            :stroke="color" stroke-width="2" stroke-miterlimit="10" />
        <path
            d="M26.4014 18.7813L7.60206 18.7813C6.29304 18.7813 5.23187 19.8424 5.23187 21.1514L5.23187 21.1533C5.23187 22.4623 6.29304 23.5235 7.60206 23.5235L26.4014 23.5235C27.7105 23.5235 28.7716 22.4623 28.7716 21.1533L28.7716 21.1514C28.7716 19.8424 27.7105 18.7813 26.4014 18.7813Z"
            :stroke="color" stroke-width="2" stroke-miterlimit="10" />
        <path
            d="M26.4014 14.0391L7.60206 14.0391C6.29304 14.0391 5.23187 15.1002 5.23187 16.4092L5.23187 16.4111C5.23187 17.7201 6.29304 18.7813 7.60206 18.7813L26.4014 18.7813C27.7105 18.7813 28.7716 17.7201 28.7716 16.4111L28.7716 16.4092C28.7716 15.1002 27.7105 14.0391 26.4014 14.0391Z"
            :stroke="color" stroke-width="2" stroke-miterlimit="10" />
        <path d="M22.2033 9.29883L11.8021 9.29883" :stroke="color" stroke-width="2" stroke-miterlimit="10" />
        <path
            d="M14.3494 17.2163L19.6544 17.2163C20.2935 17.2163 20.8115 17.7343 20.8115 18.3735L20.8115 28.0629L13.1904 28.0629L13.1904 18.3735C13.1904 17.7343 13.7084 17.2163 14.3476 17.2163L14.3494 17.2163Z"
            :fill="color" />
        <path d="M2.80402 17.8814L15.6295 5.05598C16.3506 4.33486 17.5189 4.33486 18.2382 5.05598L31.1997 18.0175"
            :stroke="color" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M28.8741 6.33984L28.8741 15.6063" :stroke="color" stroke-width="2" stroke-miterlimit="10"
            stroke-linecap="round" />
    </svg>
</template>

<script>
export default {
    name: "HebergementSVG",
    props: {
        color: {
            type: String,
            default: 'black'
        },
        width: {
            type: String,
            default: '34'
        },
        height: {
            type: String,
            default: '20'
        }
    },
}
</script>